import { render, staticRenderFns } from "./PersonalDoctorsCheckbox.vue?vue&type=template&id=dbd36c38"
import script from "./PersonalDoctorsCheckbox.vue?vue&type=script&lang=js"
export * from "./PersonalDoctorsCheckbox.vue?vue&type=script&lang=js"
import style0 from "./PersonalDoctorsCheckbox.vue?vue&type=style&index=0&id=dbd36c38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports